import { Outlet, useLocation } from 'react-router-dom'
import { useRef, useEffect, useState } from 'react'
import NavBar from './NavBar'
import MusicPlayer from './MusicPlayer'
import RoomTone from './RoomTone'
import FloatingChat from './FloatingChat'
import { useAuth } from '../context/AuthContext'

export default function Layout() {
  const { user } = useAuth()
  const isCommunity = user?.userType === 'community'
  const location = useLocation()
  const mainRef = useRef<HTMLElement>(null)
  const [transitioning, setTransitioning] = useState(false)
  const prevPath = useRef(location.pathname)

  useEffect(() => {
    if (location.pathname !== prevPath.current) {
      prevPath.current = location.pathname
      setTransitioning(true)
      const timer = setTimeout(() => setTransitioning(false), 20)
      return () => clearTimeout(timer)
    }
  }, [location.pathname])

  return (
    <div className="flex flex-col h-full">
      <NavBar />
      <main
        ref={mainRef}
        className="flex-1 overflow-y-auto overflow-x-hidden"
        style={{
          animation: transitioning ? 'none' : 'fadeIn 200ms ease-out',
          opacity: transitioning ? 0 : 1,
        }}
      >
        <Outlet />
      </main>
      {isCommunity && <RoomTone />}
      <MusicPlayer />
      {!location.pathname.startsWith('/tech/video-review') && <FloatingChat />}
    </div>
  )
}
